<div *ngIf="document">
  <div class="fx-row align-items-center justify-content-between p-16">
    <div class="fx-column fx-flex">
      <span class="title bold">
        {{'DOCUMENT.EDIT_METADATA' | translate}}
      </span>
      <span class="small light">{{document.name}}</span>
    </div>
    <mat-icon class="ml-20 dark clickable" fontSet="material-icons-outlined" (click)="onClose()">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div class="p-16">
    <div class="fx-row fx-wrap align-items-center justify-content-between approval-panel"
      [class.red-bg]="approval === 'rejected'" [class.orange-bg]="approval === 'pending'"
      [class.green-bg]="approval === 'approved'">
      <div class="fx-column fx-flex-100">
        <span class="text bold" [class.red]="approval === 'rejected'" [class.orange]="approval === 'pending'"
          [class.green]="approval === 'approved'">{{(approval === 'approved' ? "DOCUMENT.APPROVAL_APPROVED" : (approval
          === 'rejected' ?
          "DOCUMENT.APPROVAL_REJECTED" :
          "DOCUMENT.APPROVAL_PENDING")) | translate}}</span>
        <span class="text dark">{{"DOCUMENT.APPROVAL_SUBTITLE" | translate}}</span>
      </div>
      <div class="fx-column fx-flex-100">
        <mat-radio-group aria-label="Select an option" [(ngModel)]="approval" [disabled]="!canApproveDocument()"
          (change)="onApproveOrReject($event)">
          <mat-radio-button [value]="'approved'" color="primary">
            <span class="text dark">{{'DOCUMENT.APPROVAL_APPROVED' |
              translate}}</span>
          </mat-radio-button>
          <mat-radio-button [value]="'rejected'" color="primary">
            <span class="text dark">{{'DOCUMENT.APPROVAL_REJECTED' |
              translate}}</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  @if (!caseContext) {
    <div class="p-16">
      <mat-card class="annotation-instructions">
        <div class="fx-column">
          <span class="text main bold">{{'DOCUMENT.ADD_PROOFS' | translate}}</span>
          <span class="text dark">{{'DOCUMENT.ANNOTATE_DOCUMENT_HINT' | translate}}</span>
          <div class="fx-row align-items-center justify-content-start mt-10">
            <mat-slide-toggle color="main" (change)="onToggleDraw()" [checked]="isDraw">
              {{"DOCUMENT.ANNOTATE_MODE"|translate}}
            </mat-slide-toggle>
          </div>
          @if (!isDraw && !addingWithoutZone) {
            <div class="fx-row align-items-center justify-content-start mt-10">
              <span class="small main clickable" (click)="onStartWithoutZone()" [matTooltipClass]="{'uzai-tooltip':true}"
                    [matTooltip]="'DOCUMENT.ADD_WITHOUT_ZONE_HINT' | translate">{{'DOCUMENT.ADD_WITHOUT_ZONE' | translate}}</span>
            </div>
          }
          <mat-divider class="mv-10" *ngIf="isSelectingEvidenceType()"></mat-divider>
          @if (addingWithoutZone) {
            <span class="small red bold mb-10">{{'DOCUMENT.ADD_WITHOUT_ZONE' | translate}}</span>
          }
          <div class="fx-column" *ngIf="isSelectingEvidenceType()">
            <span class="small light">{{'DOCUMENT.CHOOSE_EVIDENCE_TYPE' | translate}}</span>
            <div class="fx-column align-items-start justify-content-start mt-10">
              <div class="fx-row align-items-center justify-content-start">
                <app-select label="{{'DOCUMENT.EVIDENCE_TYPE' | translate}}" [options]="evidenceTypesOptions"
                            [multiple]="false" [(value)]="evidenceType.type" [emitOnInit]="false" style="width:180px;"></app-select>
                <ng-container [ngSwitch]="evidenceType.type">
                  <app-trademark-select *ngSwitchCase="'TRADEMARK'" label="{{'DOCUMENT.TRADEMARK_EVIDENCE' | translate}}"
                                        [multiple]="true" [search]="true" class="ml-10" [value]="evidenceType.metadata"
                                        (change)="onEvidenceTypeTrademarksChange($event)" [emitOnInit]="false"
                                        style="width:210px;"></app-trademark-select>
                  <app-nice-select *ngSwitchCase="'NICE_CLASS'" label="{{'DOCUMENT.NICE_CLASS_EVIDENCE' | translate}}"
                                   [multiple]="false" [search]="true" class="ml-10" [(value)]="evidenceType.metadata"
                                   [emitOnInit]="false" style="width:210px;"></app-nice-select>
                  <app-product-service-select *ngSwitchCase="'PRODUCT_SERVICE'"
                                              label="{{'DOCUMENT.PRODUCT_SERVICE_EVIDENCE' | translate}}" [multiple]="false" [search]="true"
                                              class="ml-10" [(value)]="evidenceType.metadata" [emitOnInit]="false" style="width:210px;"
                                              [trademarks]="getTrademarks()" [niceClassification]="document.niceClassification"
                                              [editTmNice]="false"></app-product-service-select>
                  <app-territory-select *ngSwitchCase="'LOCATION'" label="{{'DOCUMENT.LOCATION_EVIDENCE' | translate}}"
                                        [multiple]="false" [search]="true" class="ml-10" [(value)]="evidenceType.metadata"
                                        [emitOnInit]="false" style="width:210px;"></app-territory-select>
                  <app-datepicker *ngSwitchCase="'DATE'" placeholder="{{'DOCUMENT.DATE_EVIDENCE' | translate}}"
                                  [(value)]="evidenceType.metadata" style="width:210px;" class="ml-10"></app-datepicker>
                  <app-daterangepicker *ngSwitchCase="'PERIOD'" placeholder="{{'DOCUMENT.PERIOD_EVIDENCE' | translate}}"
                                       [value]="{start:evidenceType.period?.start,end:evidenceType.period?.end}"
                                       (change)="onEvidenceTypePeriodChange($event)" style="width:210px;"
                                       class="ml-10"></app-daterangepicker>
                  <app-input style="width:210px;" *ngSwitchCase="'USER'"
                             placeholder="{{'DOCUMENT.USER_EVIDENCE' | translate}}..." class="ml-10" type="text"
                             [(value)]="evidenceType.metadata"></app-input>
                </ng-container>
              </div>
              <span class="small dark mt-10"
                    *ngIf="evidenceType.type === 'PRODUCT_SERVICE'">{{'DOCUMENT.RESTRICTED_PRODUCT_SERVICE_EVIDENCE_TYPE' |
                translate}}</span>
              <div class="fx-row align-items-center justify-content-start mt-10">
                <button class="button" (click)="onCancelAnnotation()" [matTooltipClass]="{'uzai-tooltip':true}"
                        [matTooltip]="'DOCUMENT.CANCEL_ANNOTATION' | translate">
                  {{'ACTIONS.CANCEL' | translate}}
                </button>
                <button class="main-button ml-10" (click)="isAnnotationDisabled() ? null : onConfirmAnnotation()"
                        [class.disabled]="isAnnotationDisabled()" [matTooltipClass]="{'uzai-tooltip':true}"
                        [matTooltip]="'DOCUMENT.CONFIRM_ANNOTATION' | translate" [matTooltipDisabled]="isAnnotationDisabled()">
                  {{'ACTIONS.VALIDATE' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  }
  <div *ngFor="let metadatum of metadataEvidences">
    <div class="p-16 fx-column">
      <div class="fx-row align-items-center justify-content-between">
        <div class="fx-column">
          <div class="fx-row align-items-center justify-content-start">
            <span class="text bold">{{metadatum.title | translate}}</span>
            @if (hasFilters(metadatum.type)) {
              <mat-icon class="main ml-5" fontSet="material-icons-outlined" inline inset
                [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'DOCUMENT.FILTERED_SECTION' | translate">filter_list</mat-icon>
            }
            @if (hasExcludedEntries(metadatum)) {
              <mat-icon class="main ml-5" fontSet="material-icons-outlined" inline inset
                [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'DOCUMENT.READ_ONLY_EDIT_TITLE' | translate">not_interested</mat-icon>
            }
          </div>

          <span class="text light" *ngIf="metadatum.entries.length === 0">{{metadatum.placeholder | translate}}</span>
        </div>
        <div class="fx-row justify-content-end">
          @if (metadatum.entries.length === 0) {
            <app-metadata-missing [document]="document"></app-metadata-missing>
          }
          @if (metadatum.type === 'LANG') {
            <mat-icon class="green clickable ml-10" fontSet="material-icons-outlined" (click)="addDocumentLang()"
              [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'DOCUMENT.ADD_DOCUMENT_LANG' | translate">add_circle_outline</mat-icon>
          }
        </div>
      </div>
      <span class="text light" *ngIf="metadatum.entries.length > 0">{{metadatum.hint | translate}}</span>
      <div class="mt-5 fx-row fx-wrap align-items-center justify-content-start">
        <div class="fx-column fx-flex-100"
          *ngFor="let entry of metadatum.entries | sort:'confidence':'desc' | limit:limits[metadatum.type]">
          <div class="fx-row align-items-center justify-content-start metadata border-box fx-flex-100"
            [class.excluded]="isExcluded(entry)" [matTooltip]="isExcluded(entry) ? ('DOCUMENT.EXCLUDED_TOOLTIP' | translate) : null"
            [matTooltipClass]="{'uzai-tooltip':true}" (mouseenter)="onMouseEnter(entry.type,entry.value)"
            (mouseleave)="onMouseLeave(entry.type,entry.value)">
            <div class="fx-flex-50 fx-wrap align-items-center justify-content-start pr-10">
              <ng-container [ngSwitch]="metadatum.type">
                <span class="text" *ngSwitchCase="metadataType.LANG">{{'LANGUAGES.'+entry.value.toLowerCase() |
                  translate}}</span>
                <span class="text" *ngSwitchCase="metadataType.CLASS">{{'DOCUMENT_CLASSES.'+entry.value.toUpperCase() |
                  translate}}</span>
                <div class="fx-column" *ngSwitchCase="metadataType.TRADEMARK">
                  <!-- Trademark with name -->
                  <div class="fx-column"
                    *ngIf="entry.value && entry.value.split('_') && entry.value.split('_')[1].length > 0">
                    <span class="text main fx-flex-100">{{entry.value.split('_')[1]}}</span>
                    <span class="small light fx-flex-100">{{entry.value.split('_')[3]}} -
                      {{entry.value.split('_')[2]}}</span>
                  </div>
                  <!-- Trademark with no name -->
                  <div class="fx-column"
                    *ngIf="entry.value && entry.value.split('_') && entry.value.split('_')[1].length == 0">
                    <span class="text main fx-flex-100">{{entry.value.split('_')[2]}}</span>
                    <span class="small light fx-flex-100">{{entry.value.split('_')[3]}}</span>
                  </div>
                </div>
                <div class="fx-row align-items-center justify-content-start" *ngSwitchCase="metadataType.NICE_CLASS">
                  <div class="chip main" [matTooltipClass]="{'uzai-tooltip':true}"
                    [matTooltip]="'NICE_CLASSES.'+entry.value | translate">
                    <span class="text main"><b>{{'NICE_CLASSES.CLASS_NUMBER' |
                        translate}}{{entry.value}}</b></span>
                  </div>
                </div>
                <div class="fx-row fx-flex-100 align-items-center justify-content-start"
                  [class.outside-trademarks]="isOutsideTrademarks(entry)" *ngSwitchCase="metadataType.LOCATION">
                  <img [src]="'/assets/countries/'+entry.value.toLowerCase()+'.svg'" class="country-flag" />
                  <span class="text ml-10">{{('TERRITORIES.'+entry.value.toUpperCase() | translate)}}</span>
                  <mat-icon class="main ml-5 outside-trademarks-icon" fontSet="material-icons-outlined"
                    *ngIf="isOutsideTrademarks(entry)" [matTooltipClass]="{'uzai-tooltip':true}"
                    [matTooltip]="'DOCUMENT.TERRITORY_OUTSIDE_TRADEMARKS' | translate">info</mat-icon>
                </div>
                <div class="fx-row align-items-center justify-content-start"
                  *ngSwitchCase="metadataType.PRODUCT_SERVICE">
                  <div class="fx-column">
                    <span class="text dark">{{getProductService(entry.value.split('_')[0])}}</span>
                    <div class="fx-row align-items-center justify-content-start">
                      <span class="small main"><b>{{getTrademark(entry.value.split('_')[1])?.name ||
                          getTrademark(entry.value.split('_')[1])?.identifierNumber}}</b></span>
                      <span class="small dark">&nbsp;-&nbsp;</span>
                      <span class="small dark">{{'NICE_CLASSES.CLASS_NUMBER' |
                        translate}}{{entry.value.split('_')[2]}}</span>
                    </div>

                  </div>
                </div>
                <span class="text" *ngSwitchCase="metadataType.DATE">{{formatDateOrPeriod(entry)}}</span>
                <span class="text" *ngSwitchCase="metadataType.USER">{{entry.value.replace('_',' ')}}</span>
              </ng-container>
            </div>
            <div class="fx-row align-items-center justify-content-start fx-flex-20">
              <span class="small light">{{(entry.manual ?
                'DOCUMENT.MANUAL_PROOF' :
                'DOCUMENT.AUTOMATIC_PROOF') | translate}}</span>
              <mat-icon class="light clickable ml-5" style="transform:scale(0.75)" *ngIf="entry.manual && entry.user"
                [cdkMenuTriggerFor]="menu">help_outline</mat-icon>
              <ng-template #menu>
                <mat-card class="menu-container p-8 elevation" cdkMenu>
                  <div class="fx-row justify-content-start align-items-center">
                    <app-avatar [user]="entry.user" [size]="24"></app-avatar>
                    <div class="fx-column align-items-start justify-content-start ml-10">
                      <span class="small">{{entry.user?.firstName}} {{entry.user?.lastName}}</span>
                      <span class="small light">{{formatDatetime($any(entry).updatedAt)}}</span>
                    </div>
                  </div>
                  @if (entry.noEvidence) {
                    <span class="small red mt-10">{{'DOCUMENT.NO_EVIDENCE_ON_DOCUMENT' | translate}}</span>
                  }
                </mat-card>
              </ng-template>
              <mat-icon class="light clickable ml-5" style="transform:scale(0.75)"
                *ngIf="!entry.manual && entry.type === metadataType.DATE && entry.timestamping"
                [matTooltip]="'DOCUMENT.TIMESTAMP_PROOF' | translate"
                [matTooltipClass]="{'uzai-tooltip':true}">help_outline</mat-icon>
              <mat-icon class="light clickable ml-5" style="transform:scale(0.75)"
                *ngIf="!entry.manual && (entry.type === metadataType.DATE || entry.type === metadataType.LOCATION) && entry.technical"
                [matTooltip]="'DOCUMENT.TECHNICAL_PROOF' | translate"
                [matTooltipClass]="{'uzai-tooltip':true}">help_outline</mat-icon>
            </div>
            <div class="fx-row align-items-center justify-content-start fx-flex-20">
              <app-metadata-confidence [value]="(entry.confidence || 0) * 100"></app-metadata-confidence>
            </div>
            <div class="icons fx-row align-items-center justify-content-end fx-flex-10">
              @if (metadatum.type === 'CLASS') {
                <mat-icon class="main clickable" fontSet="material-icons-outlined" (click)="editDocumentClass()"
                          [matTooltipClass]="{'uzai-tooltip':true}"
                          [matTooltip]="'DOCUMENT.EDIT_DOCUMENT_CLASS' | translate">edit
                </mat-icon>
              }
              @if (metadatum.type === 'LANG') {
                <mat-icon class="main clickable" fontSet="material-icons-outlined"
                          (click)="editDocumentLang(entry.value)"
                          [matTooltipClass]="{'uzai-tooltip':true}"
                          [matTooltip]="'DOCUMENT.EDIT_DOCUMENT_LANG' | translate">edit
                </mat-icon>
              }
              @if (metadatum.type !== 'CLASS' && !isCaseBlockedType(metadatum.type) && (!entry._id || metadataPendingDeletion?._id !== entry._id)) {
                <mat-icon class="red clickable" fontSet="material-icons-outlined" [class.disabled]="deleting"
                          (click)="onRemoveMetadata(metadatum.type,entry)" [matTooltipClass]="{'uzai-tooltip':true}"
                          [matTooltip]="'DOCUMENT.DELETE_METADATA_TITLE' | translate">remove_circle_outline
                </mat-icon>
              }
              @if (metadatum.type !== 'CLASS' && !isCaseBlockedType(metadatum.type) && entry._id && metadataPendingDeletion?._id === entry._id) {
                <mat-icon class="clickable green" fontSet="material-icons-outlined"
                          [class.disabled]="isValidateRemovalDisabled(metadatum.type)"
                          (click)="onValidateMetadataRemoval(metadatum.type,entry)"
                          [matTooltipClass]="{'uzai-tooltip':true}"
                          [matTooltip]="'ACTIONS.VALIDATE' | translate">checkmark
                </mat-icon>
              }
              @if (metadatum.type !== 'CLASS' && !isCaseBlockedType(metadatum.type) && entry._id && metadataPendingDeletion?._id === entry._id) {
                <mat-icon class="clickable red" fontSet="material-icons-outlined" (click)="onCancelMetadataRemoval()"
                          [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'ACTIONS.CANCEL' | translate">close
                </mat-icon>
              }
            </div>
          </div>
          <div class="evidences fx-column"
            [class.mv-16]="(entry._id && metadataPendingDeletion?._id === entry._id && evidencesPendingDeletion.length)"
            [class.collapsed]="!(entry._id && metadataPendingDeletion?._id === entry._id && evidencesPendingDeletion.length)"
            (mouseenter)="onEvidencesMouseEnter(entry.type, entry.value)"
            (mouseleave)="onMouseLeave(entry.type, entry.value)">
            <div class="fx-column">
              <span class="text bold fx-row">{{ 'DOCUMENT.SELECT_EVIDENCES_TO_DELETE' | translate }}</span>
              <span class="text light fx-row">{{ 'DOCUMENT.SELECT_EVIDENCES_TO_DELETE_HINT' | translate }}</span>
            </div>
            <div *ngFor="let evidence of evidencesPendingDeletion; let i = index; trackBy: trackEvidence" #evidence
              class="fx-row align-items-center justify-content-between" [ngClass]="{ 'top-evidence': i === 0 }"
              (mouseenter)="highlightedEvidence = evidence" (mouseleave)="highlightedEvidence = null">
              <div class="fx-row align-items-center justify-content-between">
                <mat-checkbox color="primary" [checked]="selectedEvidences.isSelected(evidence)"
                  (change)="onEvidenceToggle(evidence)"></mat-checkbox>
                <span class="text main fx-row">Evidence N°{{ i+1 }}</span>
                @if (evidence.page) {
                  <span class="small light fx-row ml-10">Page N°{{ evidence.page }}</span>
                } @else if (entry.noEvidence) {
                  <span class="small red fx-row ml-10">{{'DOCUMENT.NO_EVIDENCE_ON_DOCUMENT' | translate}}</span>
                }
              </div>

              <span class="small fx-row">
                <mat-icon [class.shown]="highlightedEvidence?._id === evidence._id" class="visibility-icon ml-10"
                  fontSet="material-icons-outlined">{{highlightedEvidence?._id === evidence._id ?
                  'visibility' :
                  'visibility_off'}}</mat-icon>
              </span>
            </div>
          </div>
        </div>
        <div class="fx-row w-100 align-items-center justify-content-end mt-10 clickable"
          *ngIf="metadatum.multiple && metadatum.entries.length > 3">
          <span class="text main"
            (click)="limits[metadatum.type] === 3 ? limits[metadatum.type] = metadatum.entries.length : limits[metadatum.type] = 3">{{(limits[metadatum.type]
            === 3 ? 'UTILS.SEE_MORE' : 'UTILS.SEE_LESS') |
            translate}}</span>
          <mat-icon class="main ml-5" fontSet="material-icons-outlined">{{limits[metadatum.type] === 3 ?
            'keyboard_arrow_down'
            :
            'keyboard_arrow_up'}}</mat-icon>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
  @if (hasMetadataWithoutSupport()) {
    <div class="fx-row align-items-center justify-content-start p-16">
      <mat-icon class="orange" fontSet="material-icons-outlined">warning</mat-icon>
      <span class="small dark ml-10">{{'DOCUMENT.DATA_WITHOUT_SUPPORT_WARNING' | translate}}</span>
    </div>
  }
</div>
